<template>
    <div>
        <component :is="tag">{{ currentValue.value }}</component>
    </div>
</template>

<script>

export default {
    name: 'ModuleText',
    data () {
        return {
            currentValue: {}
        }
    },
    props: {
        parameters: {
            type: Object,
        },
    },
    watch: {
        currentValue: {
            handler(val) {
                this.$emit('parameters-update', val);
            },
            deep: true
        }
    },
    computed: {
        tag: function() {
            return this.currentValue.tag ? this.currentValue.tag : 'span';
        }
    },
    mounted() {
        this.currentValue = JSON.parse(JSON.stringify(this.parameters));
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
